/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-duplicate-string */
import { sanitizeURL } from "../utils/utils";

export interface ApiUrls {
  readonly container: string;
  readonly micro: string;
  readonly customers?: string;
  readonly agreement?: string;
  readonly am?: string;
  readonly cashmgmt?: string;
  readonly inventory?: string;
  readonly menu?: string;
  readonly dashboard?: string;
  readonly customer?: string;
  readonly store?: string;
  readonly acimapo?: string;
  readonly dap?: string;
  readonly orderform?: string;
  readonly pricing?: string;
  readonly digiorderform?: string;
}

export interface AppConfigItem {
  readonly apiUrls: ApiUrls;
  readonly microUrl: string;
  readonly dofUrl: string;
  readonly auth: {
    readonly region: string;
    readonly userPoolId: string;
    readonly userPoolWebClientId: string;
    readonly oauth: {
      readonly domain: string;
      readonly scope?: string[];
      readonly redirectSignIn: string;
      readonly redirectSignOut: string;
      readonly responseType: string;
      readonly urlOpener: (url: string) => void;
    };
  };
}

const microUrl = {
  localhost: "http://localhost:3006",
  local: "https://local-store-racpad.rentacenter.com",
  dev: "https://dev-store-racpad.rentacenter.com",
  qa: "https://qa-store-racpad.rentacenter.com",
  uat: "https://uat-store-racpad.rentacenter.com",
  prod: "https://racpad-store.rentacenter.com",
};

const dofUrl = {
  localhost: "http://localhost:3006",
  local: "https://local-dof-racpad.rentacenter.com/",
  dev: "https://dev-dof-racpad.rentacenter.com/",
  qa: "https://qa-dof-racpad.rentacenter.com/",
  uat: "https://uat-dof-racpad.rentacenter.com/",
  prod: "https://dof-racpad.rentacenter.com/",
};

export interface AppConfig extends AppConfigItem {
  readonly appName: string;
}

export const urlOpener = (url: string): void => {
  const urlToOpen = sanitizeURL(url);

  if (urlToOpen) {
    window.open(urlToOpen, "_self");
  }
};

export const localhost: AppConfigItem = {
  apiUrls: {
    container: "https://local-racpad.rentacenter.com/api",
    micro: "https://local-store-racpad.rentacenter.com/api",
    customers: "https://local-customers-racpad.rentacenter.com/api",
    store: "https://local-store-racpad.rentacenter.com/api",
    cashmgmt: "https://local-cashmgmt-racpad.rentacenter.com/api",
    agreement: "https://local-agreement-racpad.rentacenter.com/api",
    am: "https://local-am-racpad.rentacenter.com/api",
    inventory: "https://local-inventory-racpad.rentacenter.com/api",
    menu: "https://local-menu-racpad.rentacenter.com/api",
    dashboard: "https://local-dashboard-racpad.rentacenter.com/api",
    customer: "https://local-customer-racpad.rentacenter.com/api",
    dap: "https://local-dap-racpad.rentacenter.com/api",
    acimapo: "https://local-acima-po-racpad.rentacenter.com/api",
    pricing: "https://local-pricing-racpad.rentacenter.com/api",
    digiorderform: "https://local-digiorderform-racpad.rentacenter.com/api"

  },

  microUrl: microUrl.localhost,
  dofUrl: dofUrl.localhost,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_FPWut7aB",
    userPoolWebClientId: "608s8dso4aecka8omjpukssq3n",
    oauth: {
      domain: "auth-local-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.localhost,
      redirectSignOut: microUrl.localhost,
      responseType: "token",
      urlOpener,
    },
  },
};

export const localhostIE11: AppConfigItem = { ...localhost };

export const local: AppConfigItem = {
  apiUrls: {
    acimapo: "https://local-acima-po-racpad.rentacenter.com/api",
    container: "https://local-racpad.rentacenter.com/api",
    micro: "https://local-store-racpad.rentacenter.com/api",
    customers: "https://local-customers-racpad.rentacenter.com/api",
    store: "https://local-store-racpad.rentacenter.com/api",
    cashmgmt: "https://local-cashmgmt-racpad.rentacenter.com/api",
    agreement: "https://local-agreement-racpad.rentacenter.com/api",
    am: "https://local-am-racpad.rentacenter.com/api",
    inventory: "https://local-inventory-racpad.rentacenter.com/api",
    menu: "https://local-menu-racpad.rentacenter.com/api",
    dashboard: "https://local-dashboard-racpad.rentacenter.com/api",
    customer: "https://local-customer-racpad.rentacenter.com/api",
    dap: "https://local-dap-racpad.rentacenter.com/api",
    pricing: "https://local-pricing-racpad.rentacenter.com/api",
    digiorderform: "https://local-digiorderform-racpad.rentacenter.com/api"
  },
  microUrl: microUrl.local,
  dofUrl: dofUrl.local,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_FPWut7aB",
    userPoolWebClientId: "608s8dso4aecka8omjpukssq3n",
    oauth: {
      domain: "auth-local-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.local,
      redirectSignOut: microUrl.local,
      responseType: "token",
      urlOpener,
    },
  },
};

export const dev: AppConfigItem = {
  apiUrls: {
    acimapo: "https://dev-acima-po-racpad.rentacenter.com/api",
    container: "https://dev-racpad.rentacenter.com/api",
    micro: "https://dev-storemgmt-racpad.rentacenter.com/api",
    customers: "https://dev-customers-racpad.rentacenter.com/api",
    store: "https://dev-store-racpad.rentacenter.com/api",
    cashmgmt: "https://dev-cashmgmt-racpad.rentacenter.com/api",
    am: "https://dev-am-racpad.rentacenter.com/api",
    agreement: "https://dev-agreement-racpad.rentacenter.com/api",
    inventory: "https://dev-inventory-racpad.rentacenter.com/api",
    menu: "https://dev-menu-racpad.rentacenter.com/api",
    dashboard: "https://dev-dashboard-racpad.rentacenter.com/api",
    customer: "https://dev-customer-racpad.rentacenter.com/api",
    dap: "https://dev-dap-racpad.rentacenter.com/api",
    pricing: "https://dev-pricing-racpad.rentacenter.com/api",
    digiorderform: "https://dev-digiorderform-racpad.rentacenter.com/api"

  },
  microUrl: microUrl.dev,
  dofUrl: dofUrl.dev,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_8MbOyEYG6",
    userPoolWebClientId: "47r2ihk9fehcpn9t64thdbu2tl",
    oauth: {
      domain: "auth-qa-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.dev,
      redirectSignOut: microUrl.dev,
      responseType: "token",
      urlOpener,
    },
  },
};

export const qa: AppConfigItem = {
  apiUrls: {
    acimapo: "https://qa-acima-po-racpad.rentacenter.com/api",
    container: "https://qa-racpad.rentacenter.com/api",
    micro: "https://qa-store-racpad.rentacenter.com/api",
    customers: "https://qa-customers-racpad.rentacenter.com/api",
    store: "https://qa-store-racpad.rentacenter.com/api",
    cashmgmt: "https://qa-cashmgmt-racpad.rentacenter.com/api",
    agreement: "https://qa-agreement-racpad.rentacenter.com/api",
    am: "https://qa-am-racpad.rentacenter.com/api",
    inventory: "https://qa-inventory-racpad.rentacenter.com/api",
    menu: "https://qa-menu-racpad.rentacenter.com/api",
    dashboard: "https://qa-dashboard-racpad.rentacenter.com/api",
    customer: "https://qa-customer-racpad.rentacenter.com/api",
    dap: "https://qa-dap-racpad.rentacenter.com/api",
    pricing: "https://qa-pricing-racpad.rentacenter.com/api",
    digiorderform: "https://qa-digiorderform-racpad.rentacenter.com/api"

  },
  microUrl: microUrl.qa,
  dofUrl: dofUrl.qa,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_8MbOyEYG6",
    userPoolWebClientId: "47r2ihk9fehcpn9t64thdbu2tl",
    oauth: {
      domain: "auth-qa-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.qa,
      redirectSignOut: microUrl.qa,
      responseType: "token",
      urlOpener,
    },
  },
};

export const uat: AppConfigItem = {
  apiUrls: {
    acimapo: "https://uat-acima-po-racpad.rentacenter.com/api",
    container: "https://uat-racpad.rentacenter.com/api",
    micro: "https://uat-store-racpad.rentacenter.com/api",
    customers: "https://uat-customers-racpad.rentacenter.com/api",
    store: "https://uat-store-racpad.rentacenter.com/api",
    cashmgmt: "https://uat-cashmgmt-racpad.rentacenter.com/api",
    agreement: "https://uat-agreement-racpad.rentacenter.com/api",
    am: "https://uat-am-racpad.rentacenter.com/api",
    inventory: "https://uat-inventory-racpad.rentacenter.com/api",
    menu: "https://uat-menu-racpad.rentacenter.com/api",
    dashboard: "https://uat-dashboard-racpad.rentacenter.com/api",
    customer: "https://uat-customer-racpad.rentacenter.com/api",
    dap: "https://uat-dap-racpad.rentacenter.com/api",
    pricing: "https://uat-pricing-racpad.rentacenter.com/api",
    digiorderform: "https://uat-digiorderform-racpad.rentacenter.com/api"

  },
  microUrl: microUrl.uat,
  dofUrl: dofUrl.uat,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_FBmCthpda",
    userPoolWebClientId: "1d8vgr67fr7gli9abpv9j1cb3n",
    oauth: {
      domain: "auth-uat-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.uat,
      redirectSignOut: microUrl.uat,
      responseType: "token",
      urlOpener,
    },
  },
};

export const prod: AppConfigItem = {
  apiUrls: {
    acimapo: "https://prod-acima-po-racpad.rentacenter.com/api",
    container: "https://racpad.rentacenter.com/api",
    micro: "https://store.rentacenter.com/api",
    customers: "https://customers.rentacenter.com/api",
    store: "https://store-racpad.rentacenter.com/api",
    cashmgmt: "https://cashmgmt.rentacenter.com/api",
    agreement: "https://agreement.rentacenter.com/api",
    am: "https://am-racpad.rentacenter.com/api",
    inventory: "https://inventory-racpad.rentacenter.com/api",
    menu: "https://menu-racpad.rentacenter.com/api",
    dashboard: "https://dashboard-racpad.rentacenter.com/api",
    customer: "https://customer-racpad.rentacenter.com/api",
    dap: "https://dap-racpad.rentacenter.com/api",
    pricing: "https://racpad-pricing.rentacenter.com/api",
    digiorderform: "https://digiorderform-racpad.rentacenter.com/api"

  },
  microUrl: microUrl.prod,
  dofUrl: dofUrl.prod,
  auth: {
    region: "us-east-1",
    userPoolId: "us-east-1_so5RR57Of",
    userPoolWebClientId: "50nk6ibf5lru47hesk4j0cfuu4",
    oauth: {
      domain: "auth-racpad.auth.us-east-1.amazoncognito.com",
      redirectSignIn: microUrl.prod,
      redirectSignOut: microUrl.prod,
      responseType: "token",
      urlOpener,
    },
  },
};
export const artifact: AppConfigItem = {
  apiUrls: {
    container: "_apiUrls.container",
    micro: "_apiUrls.micro",
    cashmgmt: "_apiUrls.cashmgmt",
    agreement: "_apiUrls.agreement",
    customers: "_apiUrls.customers",
    inventory: "_apiUrls.inventory",
    am: "_apiUrls.am",
    menu: "_apiUrls.menu",
    dashboard: "_apiUrls.dashboard",
    customer: "_apiUrls.customer",
    dap: "_apiUrls.dap",
    store: "_apiUrls.store",
    acimapo: "_apiUrls.acima-po",
    orderform: "_apiUrls.orderform",
    pricing: "_apiUrls.pricing",
    digiorderform: "_apiUrls.digitorderform",
  },
  microUrl: "_microUrl",
  auth: {
    region: "_auth.region",
    userPoolId: "_auth.userPoolId",
    userPoolWebClientId: "_auth.userPoolWebClientId",
    oauth: {
      domain: "_auth.oauth.domain",
      redirectSignIn: "_auth.oauth.redirectSignIn",
      redirectSignOut: "_auth.oauth.redirectSignOut",
      responseType: "_auth.oauth.responseType",
      urlOpener,
    },
  },
  dofUrl: "_apiUrls.dof",
};

let appConfigItem: AppConfigItem;

switch (process.env.REACT_APP_STAGE) {
  case "localhost":
    appConfigItem = localhost;
    break;
  case "localhost-ie11":
    appConfigItem = localhostIE11;
    break;
  case "local":
    appConfigItem = local;
    break;
  case "dev":
    appConfigItem = dev;
    break;
  case "qa":
    appConfigItem = qa;
    break;
  case "uat":
    appConfigItem = uat;
    break;
  case "prod":
    appConfigItem = prod;
    break;
  case "artifact":
    appConfigItem = artifact;
    break;
  default:
    appConfigItem = localhost;
    break;
}

export const appConfig: AppConfig = {
  appName: "Storemgmt",
  ...appConfigItem,
};
